import { KText } from '@/ui-library/components/text/KText';
import { Flex, Icon } from '@chakra-ui/react';
import { NoSearchResult } from '@/assets/icons/ats/empty';
interface NoDataFoundProps {
  label?: string;
  subLabel?: string;
}

export const NoDataFound = ({
  label = 'No data found',
  subLabel = '',
}: NoDataFoundProps) => {
  return (
    <Flex flexDir="column" alignItems="center" justifyContent="center" h="100%">
      <Icon as={NoSearchResult} h="170px" w="150px" mb="10px" />
      <KText size="lg-semi-bold" color="secondary-900" mb="10px">
        {label}
      </KText>
      {subLabel && (
        <KText
          size="sm-regular"
          color="secondary-600"
          textAlign="center"
          maxW="310px"
        >
          {subLabel}
        </KText>
      )}
    </Flex>
  );
};
